Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._ = undefined;
exports.SPACE = ' ';
exports.FILL = 'fill';
exports.NONE = 'none';
exports.DRAW_LINE_VERTICAL = 'V';
exports.DRAW_LINE_HORIZONTAL = 'H';
exports.DRAW_LINE = 'L';
exports.CLOSE_PATH = 'Z';
exports.MOVE_CURSOR = 'M';
exports.DRAW_CURVE_CUBIC_BEZIER = 'C';
exports.DRAW_CURVE_SMOOTH = 'S';
exports.DRAW_CURVE_QUADRATIC = 'Q';
exports.DRAW_CURVE_QUADRATIC_CONTINUATION = 'T';
exports.DRAW_ARC = 'A';